/* eslint-disable @typescript-eslint/no-explicit-any */

export type Ref = React.RefCallback<any> | React.MutableRefObject<any> | null;
export const mergeRefs = (...refs: Ref[]): Ref => {
  if (!refs.length) return refs[0];
  return (inst: React.RefCallback<any>): void => {
    for (const ref of refs) {
      if (typeof ref === 'function') ref(inst);
      else if (ref) ref.current = inst;
    }
  };
};

export const isDarkColor = (color: string): boolean => {
  const [, hue] = color.split('.');
  return Number(hue) >= 500;
};

export const delay = (time = 100) => new Promise((resolve) => setTimeout(resolve, time));

export const browserLanguages = navigator.languages || ['en-US'];
export const browserLanguage = navigator.language;
